export { LIST_FREE_DOMAINS } from './freeDomains';

export {
  TEAM_OPTIONS,
  COMPANY_SIZES,
  CRMS_OPTIONS,
  WHAT_BROUGHT_YOU_TO_PANDADOC_OPTIONS,
  ESIGN_COMPETITOR_OPTIONS,
} from './options';

export enum AnalyticKey {
  CLICK_ID = 'cid',
  GOOGLE_CLICK_ID = 'gclid',
  ANONYMOUS_ID = 'ajs_anonymous_id',
  EXPERIMENT_INFO = 'a_b_test_info',
  GA_CLIENT_ID = 'google_analytics_client_id',
  DEVICE = 'device',
  SIGNUP_SOURCE = 'signup_source',
  GA_COOKIE = '_ga',
}

export enum UtmKey {
  UTM_CAMPAIGN_SEARCH_PARAM_NAME = 'utm_campaign',
  UTM_CONTENT_SEARCH_PARAM_NAME = 'utm_content',
  UTM_MEDIUM_SEARCH_PARAM_NAME = 'utm_medium',
  UTM_SOURCE_SEARCH_PARAM_NAME = 'utm_source',
  UTM_TERM_SEARCH_PARAM_NAME = 'utm_term',
  UTM_CREATIVE_SEARCH_PARAM_NAME = 'utm_creative',
}

export const MAX_UTM_LENGTH = 64;

export enum UserPropertyId {
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PASSWORD = 'password',
  PHONE = 'phone_number',
  RECEIVE_UPDATES = 'receive_updates',
  TERMS_AND_POLICY = 'terms_and_policy',
  COMPANY_NAME = 'company_name',
  COMPANY_SIZE = 'company_size',
  CRM = 'crm',
  WHAT_BROUGHT_YOU_TO_PANDADOC = 'what_brought_you_to_pandadoc',
  TEAM = 'team',
  ESIGN_COMPETITOR = 'esign_competitor',
}

export const LIST_STUDENT_DOMAIN_PARTS = [
  'k12.',
  '.edu',
  '.TEC.',
  '.lib.',
  '.cc.',
  '.college',
  '.ac.',
  'student.',
  'students.',
  'ccsd.',
];

export enum EmailType {
  FREE = 'free',
  BUSINESS = 'business',
  STUDENT = 'student',
}
